import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change, untouch } from "redux-form";
import { toastr } from "react-redux-toastr";

import TextField from "../../components/Fields/TextField";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import FieldValidation from "../../components/Validation/FieldValidation";
import logo from "../../img/e-registro-logo.png";
import UfField from "../UfFields/UfField";
import CityField from "../UfFields/CityField";
import MaskDate from "../../components/Util/MaskDate";

import api from "../../api/apiUtil";

import Title from "../../components/Layout/Title";
import SelectField from "../../components/Fields/SelectField";

class FinancialPreRegistration extends React.Component {
  constructor() {
    super();
    this.state = {
      success: false,
      ufSystem: [
        { sigla: "AC", descricao: "Acre" },
        { sigla: "AL", descricao: "Alagoas" },
        { sigla: "AP", descricao: "Amapá" },
        { sigla: "AM", descricao: "Amazonas" },
        { sigla: "BA", descricao: "Bahia" },
        { sigla: "CE", descricao: "Ceará" },
        { sigla: "DF", descricao: "Distrito Federal" },
        { sigla: "ES", descricao: "Espírito Santo" },
        { sigla: "GO", descricao: "Goiás" },
        { sigla: "MA", descricao: "Maranhão" },
        { sigla: "MT", descricao: "Mato Grosso" },
        { sigla: "MS", descricao: "Mato Grosso do Sul" },
        { sigla: "MG", descricao: "Minas Gerais" },
        { sigla: "PA", descricao: "Pará" },
        { sigla: "PB", descricao: "Paraíba" },
        { sigla: "PR", descricao: "Paraná" },
        { sigla: "PE", descricao: "Pernambuco" },
        { sigla: "PI", descricao: "Piauí" },
        { sigla: "RJ", descricao: "Rio de Janeiro" },
        { sigla: "RN", descricao: "Rio Grande do Norte" },
        { sigla: "RS", descricao: "Rio Grande do Sul" },
        { sigla: "RO", descricao: "Rondônia" },
        { sigla: "RR", descricao: "Roraima" },
        { sigla: "SC", descricao: "Santa Catarina" },
        { sigla: "SP", descricao: "São Paulo" },
        { sigla: "SE", descricao: "Sergipe" },
        { sigla: "TO", descricao: "Tocantins" },
      ],
      endCodMunicipio: null,
    };
  }

  handleBlurCEP(event) {
    if (event.target.value && event.target.value.replace(/\D/g, "").length === 8) {
      fetch(`https://viacep.com.br/ws/${event.target.value}/json/`)
        .then((response) => response.json())
        .then((data) => {
          if (!data.erro) {
            this.props.dispatch(change("FinancialPreRegistrationForm", "endereco", data.logradouro ? data.logradouro.toUpperCase() : ""));
            this.props.dispatch(change("FinancialPreRegistrationForm", "endComplemento", data.complemento ? data.complemento.toUpperCase() : ""));
            this.props.dispatch(change("FinancialPreRegistrationForm", "endBairro", data.bairro ? data.bairro.substring(0, 45).toUpperCase() : ""));
            this.props.dispatch(change("FinancialPreRegistrationForm", "endUf", data.uf));
            this.setState({ endCodMunicipio: data.siafi });
            this.props.dispatch(change("FinancialPreRegistrationForm", "endMunicipio", data.localidade ? data.localidade.toUpperCase() : ""));
          } else {
            this.props.dispatch(change("FinancialPreRegistrationForm", "endereco", ""));
            this.props.dispatch(change("FinancialPreRegistrationForm", "endComplemento", ""));
            this.props.dispatch(change("FinancialPreRegistrationForm", "endBairro", ""));
            this.props.dispatch(change("FinancialPreRegistrationForm", "endUf", ""));
            this.setState({ endCodMunicipio: null });
            this.props.dispatch(change("FinancialPreRegistrationForm", "endMunicipio", ""));
            toastr.warning("Atenção", "CEP não encontrado!");
          }
        })
        .catch((error) => {
          toastr.error("Erro", "Ocorreu um erro ao consultar o CEP.");
        });
    }
  }

  formSubmit(values) {
    const financialData = {
      cnpj: values.cnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase(),
      razaoSocial: values.razaoSocial,
      nomeFantasia: values.nomeFantasia,
      inscricaoEstadual: values.inscricaoEstadual,
      endereco: values.endereco,
      endNumero: values.endNumero,
      endComplemento: values.endComplemento,
      endBairro: values.endBairro,
      // endCodMunicipio: values.endCodMunicipio,
      endCodMunicipio: this.state.endCodMunicipio,
      endUf: values.endUf,
      endCep: values.endCep,
      dddTelefone: values.dddTelefone,
      numTelefone: values.numTelefone,
    };

    Promise.resolve(api.Financial.createPreRegistration(financialData))
      .then((ret) => {
        this.setState({ success: true });
        toastr.success("Sucesso", "Pré-cadastro realizado com sucesso!");
      })
      .catch((error) => {
        if (error && error.response && error.response.body && error.response.body.message) {
          toastr.error("Erro", error.response.body.message);
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar o pré-cadastro.");
        }
      });
  }

  render() {
    if (this.state.success) {
      return (
        <div>
          <div className="color-line-ereg"></div>
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                <div className="hpanel">
                  <div className="panel-heading">
                    <h5>Pré-cadastro de Financeira</h5>
                  </div>
                  <div className="panel-body">
                    <div className="text-center">
                      <h4>Pré-cadastro realizado com sucesso!</h4>
                      <p>Obrigado pelo seu cadastro. Em breve entraremos em contato.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    const { handleSubmit } = this.props;
    return (
      <div>
        <div className="color-line-ereg"></div>
        <div className="login-img-container">
          <img src={logo} />
        </div>
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <h5>Pré-cadastro de Financeira</h5>
                </div>
                <div className="panel-body">
                  <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmit.bind(this))}>
                    <div className="row">
                      <div className="col-md-4">
                        <Field name="razaoSocial" label="Razão Social" required component={TextField} type="text" validate={[FieldValidation.required]} />
                      </div>
                      <div className="col-md-2">
                        <Field name="cnpj" label="CNPJ" component={TextField} required type="text" validate={[FieldValidation.required]} normalize={FieldNormalize.CNPJ} />
                      </div>
                      <div className="col-md-2">
                        <Field name="inscricaoEstadual" label="Inscrição Estadual" component={TextField} type="text" normalize={FieldNormalize.NUMBER} />
                      </div>
                      <div className="col-md-4">
                        <Field name="nomeFantasia" label="Nome Fantasia" component={TextField} type="text" maxlength={100} />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-2">
                        <Field
                          name="endCep"
                          label="CEP"
                          required
                          component={TextField}
                          type="text"
                          normalize={FieldNormalize.CEP}
                          validate={[FieldValidation.required]}
                          onBlur={this.handleBlurCEP.bind(this)}
                        />
                      </div>
                      <div className="col-md-1">
                        <Field name="endUf" label="UF" required data={this.state.ufSystem} textField="sigla" blank component={SelectField} type="text" validate={[FieldValidation.required]} disabled />
                      </div>
                      <div className="col-md-2">
                        <Field name="endMunicipio" label="Município" required component={TextField} type="text" validate={[FieldValidation.required]} disabled />
                      </div>
                      <div className="col-md-6">
                        <Field name="endereco" label="Endereço" required component={TextField} type="text" validate={[FieldValidation.required]} />
                      </div>
                      <div className="col-md-1">
                        <Field name="endNumero" label="Número" required component={TextField} type="text" normalize={FieldNormalize.NUMBER} validate={[FieldValidation.required]} />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-5">
                        <Field name="endComplemento" label="Complemento" component={TextField} type="text" />
                      </div>
                      <div className="col-md-4">
                        <Field name="endBairro" label="Bairro" required component={TextField} type="text" validate={[FieldValidation.required]} />
                      </div>
                      <div className="col-md-1">
                        <Field name="dddTelefone" label="DDD" required component={TextField} type="text" maxlength={2} normalize={FieldNormalize.NUMBER} validate={[FieldValidation.required]} />
                      </div>
                      <div className="col-md-2">
                        <Field name="numTelefone" label="Telefone" required component={TextField} type="text" validate={[FieldValidation.required]} normalize={FieldNormalize.PHONE_N_DDD} />
                      </div>
                    </div>

                    <div className="row"></div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-center" style={{ marginTop: "20px" }}>
                          <button type="submit" className="btn btn-success">
                            Realizar Pré-cadastro
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedUf: state.ufSystem ? state.ufSystem.selectedUf : null,
});

const mapDispatchToProps = (dispatch) => ({});

// Validation function for the form
const validate = (values) => {
  const errors = {};

  if (!values.razaoSocial || values.razaoSocial.trim() === "") {
    errors.razaoSocial = "Campo obrigatório";
  } else if (values.razaoSocial.length > 45) {
    errors.razaoSocial = "Máximo de 45 caracteres";
  }

  if (!values.cnpj || values.cnpj.replace(/[^0-9A-Za-z]/g, "").length !== 14) {
    errors.cnpj = "CNPJ inválido";
  }

  if (!values.endCep || values.endCep.replace(/\D/g, "").length !== 8) {
    errors.endCep = "CEP inválido";
  }

  if (!values.endereco || values.endereco.trim() === "") {
    errors.endereco = "Campo obrigatório";
  } else if (values.endereco.length > 30) {
    errors.endereco = "Máximo de 30 caracteres";
  }

  if (!values.endNumero || values.endNumero.trim() === "") {
    errors.endNumero = "Campo obrigatório";
  } else if (values.endNumero.length > 5) {
    errors.endNumero = "Máximo de 5 caracteres";
  }

  if (!values.endBairro || values.endBairro.trim() === "") {
    errors.endBairro = "Campo obrigatório";
  } else if (values.endBairro.length > 20) {
    errors.endBairro = "Máximo de 20 caracteres";
  }

  if (!values.endUf) {
    errors.endUf = "Campo obrigatório";
  }

  if (!values.endCodMunicipio) {
    errors.endCodMunicipio = "Campo obrigatório";
  }

  if (!values.dddTelefone || values.dddTelefone.trim() === "") {
    errors.dddTelefone = "Campo obrigatório";
  } else if (!/^\d{2}$/.test(values.dddTelefone.replace(/\D/g, ""))) {
    errors.dddTelefone = "DDD inválido";
  }

  if (!values.numTelefone || values.numTelefone.trim() === "") {
    errors.numTelefone = "Campo obrigatório";
  } else if (values.numTelefone.replace(/\D/g, "").length < 8 || values.numTelefone.replace(/\D/g, "").length > 9) {
    errors.numTelefone = "Telefone inválido";
  }

  if (values.inscricaoEstadual && values.inscricaoEstadual.length > 45) {
    errors.inscricaoEstadual = "Máximo de 45 caracteres";
  }

  if (values.nomeFantasia && values.nomeFantasia.length > 100) {
    errors.nomeFantasia = "Máximo de 100 caracteres";
  }

  if (values.endComplemento && values.endComplemento.length > 20) {
    errors.endComplemento = "Máximo de 20 caracteres";
  }

  return errors;
};

const form = reduxForm({
  form: "FinancialPreRegistrationForm",
  validate,
});

export default connect(mapStateToProps, mapDispatchToProps)(form(FinancialPreRegistration));
